var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.UserMasterSearch,{ref:"search",on:{"search":_setup.onSearch}})],1),_c('v-col',{attrs:{"cols":"12"}},[_c(_setup.UserMasterTable,{attrs:{"items":_setup.items},on:{"submit":_setup.onSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }